import React from 'react'
import Footer from './Footer'

const Managharmon = () => {
    return (
        <>
            <div className='heading'>
                <h1>Management of Hormonal Disturbance </h1>
                <p>Home / Management of Hormonal Disturbance</p>
            </div>

            <div className='desiese'>

                <div className='desiese1'>


                    <p><strong>Medication:</strong> Depending on the underlying cause of hormonal disturbance, medication may be prescribed. For example, hormone replacement therapy (HRT) might be recommended for menopausal symptoms, or medications to regulate thyroid function for thyroid disorders.</p>
                    <p><strong>Lifestyle Changes:</strong> Adopting a healthy lifestyle can help manage hormonal imbalances. This includes regular exercise, a balanced diet rich in fruits, vegetables, and whole grains, stress management techniques such as meditation or yoga, and adequate sleep.</p>
                    <p><strong>Nutritional Support:</strong> Certain nutrients are essential for hormone production and balance. Ensuring adequate intake of vitamins and minerals such as vitamin D, B vitamins, magnesium, and zinc can support hormonal health. Consultation with a healthcare provider or nutritionist may be helpful to address specific deficiencies.</p>
                    <p><strong>Weight Management:</strong> Maintaining a healthy weight is important for hormonal balance, as excess fat can lead to increased production of certain hormones. Losing weight through a combination of diet and exercise can help regulate hormone levels, especially in conditions like polycystic ovary syndrome (PCOS) or insulin resistance.</p>
                    <p><strong>Stress Reduction:</strong> Chronic stress can disrupt hormone levels, so it's important to manage stress through relaxation techniques, hobbies, social support, and possibly therapy or counseling.</p>
                    <p><strong>Avoiding Hormone Disruptors:</strong> Minimize exposure to chemicals that can disrupt hormone function, such as certain plastics, pesticides, and some personal care products. Opt for natural, organic options when possible.</p>






                </div>



                <div className='desiese2'>
                    <h1>Dr. Mansi Shukul</h1>
                    <h2>Obstetrician, Gynecologist, & Infertility
                        M.B.B.S , D.G.O. (A.M.U) D.N.B. (Apollo Hospital).
                    </h2>
                    <p>F.M.A.S (Fellowship in Minimal Access Surgery).</p>
                    <p>M.R.C.O.G. (UK), M.N.A.M.S.</p>
                    <p>Ex. SR at Sunder Lal Jain Hospital, Delhi.</p>
                    <p>Ex. SR at Career Institute of Medical Science, Lucknow.</p>
                    <p>Ex. Laparoscopic Consultant at Lakshmi Madhavan Hospital, Tamil Nadu.</p>


                </div>

                <div className='desiese3'>
                    <h1>Dr. Garima Gupta</h1>
                    <h2>Obstetrician, Gynecologist, & Infertility
                        M,B.B.S , D.G.O. ,(Lady Hardinge , New Delhi).</h2>

                    <p>D.N.B. (D.D.U Hospital, New Delhi)</p>
                    <p>F.I.C.O.G., M.R.C.O.G. (UK), M.N.A.M.S.</p>
                    <p>Ex. SR at D.D.U Hospital, New Delhi.</p>
                    <p>Ex. SR at Dr. RML Hospital & P.G.I.M.E.R., New Delhi.</p>
                    <p>Ex. Consultant at Srijan Fertility Institute, Patna.</p>

                </div>
            </div>

            <br />

            <Footer />
        </>
    )
}

export default Managharmon